<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="{name: 'dashboard'}">Portada</router-link>
                            </li>
                            <li>
                                <span>Huéspedes</span>
                            </li>
                            <li class="active">
                                <span>Lista de huéspedes</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        Lista de huéspedes
                    </h2>
                    <small>Gestionar huéspedes</small>
                </div>
            </div>

        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Huéspedes
                </div>
                <div class="panel-body">
                    <div class="m-b-md">
                        <div class="m-b-sm">
                            <button class="btn btn-default" type="button" data-toggle="collapse"
                                    data-target="#guestListFilters" aria-expanded="false" @click="toggleFilter"
                                    aria-controls="guestListFilters">
                                Filtros
                                <i :class="'fa fa-caret-' + (filterFlag ? 'down' : 'up')"></i>
                            </button>
                            <router-link class="btn btn-primary btn-outline pull-right" tag="button"
                                         :to="guestNewRoute"> Crear
                                <i class="fa fa-plus"></i></router-link>
                        </div>
                        <div class="collapse" id="guestListFilters">
                            <div class="form">
                                <div class="row">
                                    <div v-if="!isHotel" class="col-md-3 form-group">
                                        <label>Hotel</label>
                                        <custom-input tipo="select" :field="$v.filters.hotel" :items="hotels"/>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Código</label>
                                        <custom-input tipo="text" :field="$v.filters.code"/>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Nombre</label>
                                        <custom-input tipo="text" :field="$v.filters.firstName"/>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Apellido</label>
                                        <custom-input tipo="text" :field="$v.filters.lastName"/>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Correo electrónico</label>
                                        <custom-input tipo="text" :field="$v.filters.email"/>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label>Estado</label>
                                        <custom-input tipo="select" :field="$v.filters.status" :items="statuses"/>
                                    </div>
                                </div>
                                <div class="row text-center">
                                    <div class="col-md-12">
                                        <button type="button" class="btn btn-default" @click="clear">
                                            Limpiar filtros
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                        <button type="button" class="btn btn-primary" @click="search">
                                            Aplicar filtros
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="table-responsive">
                        <table cellpadding="1" cellspacing="1" class="table table-bordered table-striped">
                            <thead>
                            <tr>
                                <th>Hotel</th>
                                <th>Código</th>
                                <th>Nombre</th>
                                <th>Apellido</th>
                                <th>Correo electrónico</th>
                                <th>ID</th>
                                <th>Celular</th>
                                <th>Check-in</th>
                                <th>Check-out</th>
                                <th>Estado</th>
                                <th style="width:6%">Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="o in data" :key="o.id">
                                <td align="center"><span>{{o.hotelDesc}}</span></td>
                                <td align="center"><span>{{o.code}}</span></td>
                                <td><span>{{o.firstName}}</span></td>
                                <td><span>{{o.lastName}}</span></td>
                                <td align="center"><span>{{o.email}}</span></td>
                                <td align="center"><span>{{o.identity}}</span></td>
                                <td align="center"><span>{{o.phone}}</span></td>
                                <td align="center"><span>{{o.arrivalAtStr}}</span></td>
                                <td align="center"><span>{{o.departureAtStr}}</span></td>
                                <td align="center">
                                    <span :class="getClass(o.status)">{{getLabel(o.status)}}</span>
                                </td>
                                <td align="center" class="action-cell">
                                    <div class="dropdown" v-if="o.status !== 3">
                                        <a type="button" class="dropdown-toggle" data-toggle="dropdown"><i
                                            class="fa fa-gear"></i></a>
                                        <ul class="dropdown-menu filedropdown m-l pull-right">
                                            <li><a @click="goToEdit(o.id)">EDITAR</a></li>
                                            <li><a @click="sendGuestCodeEmail(o.id)">REENVIAR CÓDIGO</a></li>
                                            <li><a @click="deactivate(o.id)">INACTIVAR</a></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <paginator :total-elements="totalElements" :page-number="pageNumber" :total-pages="totalPages"
                               :change-page="changePage"/>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import {GUEST_EDIT, GUEST_LIST, GUEST_NEW} from "../../router/routes";
    import CustomInput from '../common/CustomInput.vue'
    import StatusBadge from '../common/StatusBadge.vue'
    import {mapGetters} from 'vuex'

    import {maxLength} from 'vuelidate/lib/validators'
    import {guestStatusList} from '../../util/selectOptions'
    import {paginationMixin} from '../../util/paginationMixin'
    import {filterMixin} from '../../util/filterMixin'
    import Alert from "../../util/alert";
    import HotelService from "../../services/HotelService";
    import GuestService from "../../services/GuestService";
    import Util from '../../util/util';

    export default {
        name: GUEST_LIST.name,
        mixins: [
            paginationMixin,
            filterMixin
        ],
        components: {CustomInput, StatusBadge},
        data: () => ({
            guestNewRoute: GUEST_NEW.route,
            data: [],
            hotels: [],
            statuses: guestStatusList,
            filters: {
                hotel: null,
                code: null,
                firstName: null,
                lastName: null,
                email: null,
                status: null,
            }
        }),
        validations: {
            filters: {
                hotel: {},
                code: {maxLength: maxLength(10)},
                firstName: {maxLength: maxLength(50)},
                lastName: {maxLength: maxLength(50)},
                email: {maxLength: maxLength(45)},
                status: {},
            }
        },
        computed: {
            ...mapGetters([
                'isHotel',
            ]),
        },
        methods: {
            async init() {
                const self = this;
                this.getData();
                if (!self.isHotel) {
                    self.hotels = [];
                    const hotelsData = (await HotelService.filterHotels()).data.payload.content;
                    hotelsData.forEach(it => {
                        self.hotels.push({key: it.id, value: it.name})
                    });
                }
            },
            search() {
                this.$v.$touch();
                if (this.$v.$error) return;
                const self = this;

                const data = {
                    ...self.filters, ...{
                        status: self.filters.status ? self.filters.status.key : null,
                        hotelId: self.filters.hotel ? self.filters.hotel.key : null
                    }
                };
                self.getData(data)
            },
            clear() {
                const self = this;
                self.filters.firstName = self.filters.lastName = self.filters.email = self.filters.status =
                    self.filters.hotel = self.filters.code = null;
                self.$v.$reset();
            },
            goToEdit(guestId) {
                this.$router.push({path: GUEST_EDIT.route.replace(":guestId", guestId)})
            },
            async sendGuestCodeEmail(guestId) {
                try {
                    await GuestService.sendGuestCodeEmail(guestId);
                    Alert.mensajeExito("Correo electrónico enviado.")
                } catch (err) {
                    Alert.mensajeError(err.message);
                }
            },
            onToggleState(guest) {
                const self = this;
                const guests = self.data.filter((o) => {
                    return o.id === guest.id;
                });
                const guestFiltered = guests && guests.length > 0 ? guests[0] : null;
                const index = self.data.indexOf(guestFiltered);
                self.$set(self.data, index, guest);
            },
            async deactivate(guestId) {
                const self = this;
                try {
                    Alert.confirmacion("Al inactivar a un huésped, los viajes que haya reservado no se cancelarán. Sin embargo, no podrá realizar nuevos viajes. Además esta acción no se puede revertir ¿Deseas continuar?",
                        null,
                        async function () {
                            const guestUpdated = (await GuestService.deactivateGuest(guestId)).data.payload;
                            self.onToggleState(guestUpdated);
                        });
                } catch (err) {
                    Alert.mensajeError(err.message);
                }
            },
            async getData(params = {}, page = 1) {
                const self = this;
                params.page = page - 1;
                params.size = self.pageSize;
                self.params = params;
                self.loading = true;
                const payload = (await GuestService.filterGuests(params)).data.payload;
                self.data = payload.content;
                self.totalPages = payload.totalPages;
                self.totalElements = payload.totalElements;
                self.pageNumber = payload.number + 1;
                self.loading = false;
            },
            getClass(status) {
                return `badge badge-${Util.getOptionByKey(guestStatusList, status).color}`;
            },
            getLabel(status) {
                return Util.getOptionByKey(guestStatusList, status).value;
            },
        },
        async mounted() {
            const self = this;
            self.init();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/guest/GuestList.vue